import React, {useState, useEffect , useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Space, Divider, Table, Flex, Spin, Descriptions } from 'antd';
import { SolutionOutlined, EyeOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { dateFormat, shortDateFormat } from '../../utils';
import AddSeason from '../../components/AddSeason';
import * as Setting from '../../utils/AuthUtils';
import { MeContext } from '../../context/';
import { getPhoto } from '../../utils/ComponentUtils';
import UpdateLeague from '../../components/UpdateLeague';
import { motion } from 'motion/react';
import LocationMap from '../../components/LocationMap';
import AddLeagueLocation from '../../components/AddLeagueLocation';
import DeleteLeagueLocation from '../../components/DeleteLeagueLocation';
import { useTranslation } from 'react-i18next';
import LeagueSocial from '../../components/LeagueSocial';
import { generateSeasonCols, tournamentsCols } from '../../utils/DataUtils';
import AddTournament from '../../components/AddTournament';

function League(props) {
  // console.warn('props di League: ',props);
  const me = useContext(MeContext);
  const [width, setWidth] = useState(window.innerWidth);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
  const [selectedLocation, setSelectedLocation] = useState(null);
  const { t } = useTranslation();

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  function formatStatus(league) {
    if (league && league.status) {
      return t('leagues.active'); //"Active";
    }
    return t('leagues.inactive'); //"Inactive";
  }

  function formatPrefixStatus(league) {
    if (league && league.status) {
      return (<CheckCircleTwoTone twoToneColor="#52c41a" />)
    }
    return (<CloseCircleTwoTone twoToneColor="#eb2f96" />)
  }

  function checkStatus(event) {
      if (event && event.isDone === true) {
        return 'card-success';
      }
      return '';
  }

  useEffect(() => {
    // console.warn('onEffect di League page!');
    const rights = {isAdmin: false, isReferral: false};
    rights.isAdmin = (me && me.payLoad ? me.payLoad.isAdmin : false)
    const lid = (me && me.payLoad ? me.payLoad.leaguesManaged : 0)
    // console.warn('valori di lid e props.id: ', lid, ' , ', props.id);
    rights.isReferral = (lid === parseInt(props.id) ? true : false)
    // console.warn('stato di hasRights: ', hasRights);
    setHasRights(rights)
    if (props.league.data && props.league.data.payLoad && props.league.data.payLoad.locations && props.league.data.payLoad.locations.length > 0) {
      setSelectedLocation(props.league.data.payLoad.locations[0]);
    } 
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [me, props])

  const locationCols = [
    {
      title: t('locations.name'),
      dataIndex: 'name',
      key: 'name',
      width: '90%',
      render: (name, record) => (
        <div>
          {name}<br/>{record.address}
        </div>
      )
    },
    {
      title: t('locations.actions'),
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => (
        <Space size="middle">
          <DeleteLeagueLocation location={record} leagueId={props.id} />
        </Space>
      ),
    },
  ];

  const league = (props.league.data && props.league.data.payLoad !== null ? props.league.data.payLoad : {});
  const seasons = (props.seasons.data && props.seasons.data.payLoad !== null ? props.seasons.data.payLoad : []);
  const events = (props.events.data && props.events.data.payLoad !== null ? props.events.data.payLoad : []);
  const locations = (props.league.data && props.league.data.payLoad !== null && props.league.data.payLoad.locations ? props.league.data.payLoad.locations : []);
  const isMobile = width <= 768;
  
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
    <h1>
      {league.leagueName}
    </h1>
    <Card loading={props.league.pending && props.seasons.pending} >
      { league.imageUrl !== '' &&
        <Row gutter={16} justify="center" align="middle">
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <img style={{ width: '50%'}} alt={league.leagueName} src={getPhoto(league.imageUrl)}></img>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <Card title={t('leagues.referral')} className="league-desc">
                <span><SolutionOutlined /> {league.referrerName}</span>
              </Card>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <Card title={t('leagues.social')} className="league-desc">
                <span><LeagueSocial social={league.facebookUrl} /></span>
              </Card>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Card title={t('leagues.status')} className="league-desc">
              <span>{formatPrefixStatus(league)} {formatStatus(league)}</span>
            </Card>
          </Col>
        </Row>
      }
      { league.imageUrl === '' &&
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('leagues.status')} className="league-desc">
              <span>{formatPrefixStatus(league)} {formatStatus(league)}</span>
            </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('leagues.referral')} className="league-desc">
              <span><SolutionOutlined /> {league.referrerName}</span>
            </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('leagues.social')} className="league-desc">
              <span><LeagueSocial social={league.facebookUrl} /></span>
            </Card>
        </Col>
      </Row>
      }
      { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral ) && 
            <Row justify="center">
              <Col span={24}><UpdateLeague league={league} rights={hasRights}/></Col>
            </Row>
      }
      <Divider>{t('locations.title')}</Divider>
      { locations && locations.length === 0 &&
          <p> {t('leagues.nolocations')} </p>
      }
      { locations && locations.length === 1 &&
          <div><Row justify="center" gutter={[16, 24]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Row justify="center">
                  <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                    {locations[0].name}<br/>{locations[0].address}
                  </Col>
                  { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral ) &&
                    <Col xs={24} sm={24} md={24} lg={2} xl={2} style={{ marginBottom: '10px' }}>
                      <DeleteLeagueLocation location={locations[0]} leagueId={league.id} />
                    </Col>
                  }
                </Row>
              </Col>
          </Row>
          <Row justify="center" gutter={[16, 24]} style={{ marginTop: '5px' }}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <LocationMap location={locations[0]} /> 
              </Col>
          </Row>
          </div>
      }
      { locations && locations.length > 1 &&
        <Row justify="center" gutter={[16, 24]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <LocationMap location={selectedLocation} multipleLocations={locations} /> 
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Card variant="borderless" style={{ boxShadow: 'none', padding: 0 }}>
              <Table
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => { 
                      // console.warn('record cliccato: ', record);
                      event.preventDefault();
                      setSelectedLocation(record);
                    }, // click row
                  };
                }}
                rowClassName={(record, index) => selectedLocation && record.id === selectedLocation.id ? 'table-row-selected' : '' }
                columns={locationCols} 
                dataSource={locations} 
                pagination={false} 
                loading={props.league.pending}
                showHeader={false}
              />
            </Card>
          </Col>
        </Row>
      }
      { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral ) &&
        <Row justify="center">
          <Col xs={24} sm={24} md={24} lg={6} xl={6}><AddLeagueLocation leagueId={league.id} rights={hasRights}/></Col>
        </Row>
      }
      <Divider>{t('seasons.title')}</Divider>
      {!isMobile &&
        <Row gutter={[16, 24]} style={{ marginBottom: '20px' }}>
          <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
            <div>
              <Card type="inner">
                { (hasRights.isAdmin || hasRights.isReferral) &&
                  <div style={{ marginBottom: '20px' }}><AddSeason /></div>
                }
                <Table
                  rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
                  columns={generateSeasonCols(t)} 
                  dataSource={seasons} 
                  pagination={false} 
                  loading={props.seasons.pending}
                />
              </Card>
            </div>
          </Col>
        </Row>
      }
      {isMobile &&
      <div>
        { (hasRights.isAdmin || hasRights.isReferral) &&
            <div style={{ marginBottom: '20px' }}>
              <AddSeason />
            </div>
        }
        {
          props.seasons.pending &&
          <Flex gap="middle" vertical>
            <Flex gap="middle">
              <Spin tip="Loading" size="large">
                <div style={{ padding: 50, background: 'rgba(0, 0, 0, 0.05)', borderRadius: 4 }} />
              </Spin>
            </Flex>
          </Flex>
        }
        {
          seasons.map(season => {
            const ps = [
              {
                key: '1',
                label: t('seasons.startDate'),
                children : <Space>{shortDateFormat(season.startDate)}</Space>
              },
              {
                key: '2',
                label: t('seasons.endDate'),
                children: <Space>{shortDateFormat(season.endDate)}</Space>
              },
              {
                key: '3',
                label: t('stages.total'),
                children: <Space>{season.scheduledStages}</Space>
              },
              {
                key: '4',
                label: t('stages.played'),
                children: <Space>{season.stagesPlayed}</Space>
              },
            ]
            return (
              <Col span={24}>
                <Link to={'/seasons/'+season.id+'/'}>
                  <Card className="season-card" style= {{ width: '100%', marginBottom: '8px'}} title={season.name}>
                    <Descriptions size="small" title={t('seasons.info')} items={ps} column={{ xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }} />
                  </Card>
                </Link>
              </Col>
            )
        })
        }
      </div>
      }
      <Divider>Events</Divider>
      {!isMobile &&
        <Row gutter={[16, 24]} style={{ marginBottom: '20px' }}>
          <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
            <div>
              <Card type="inner">
                { (hasRights.isAdmin || hasRights.isReferral) &&
                  <div style={{ marginBottom: '20px' }}><AddTournament /></div>
                }
                <Table
                  rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
                  columns={tournamentsCols} 
                  dataSource={events} 
                  pagination={false} 
                  loading={props.events.pending}
                />   
              </Card>
            </div>
          </Col>
        </Row>
      }{isMobile &&
        events.map(event => {
            const pe = [
              {
                key: '1',
                label: t('tournaments.startDate'),
                children : <Space>{shortDateFormat(event.date)}</Space>
              },
              {
                key: '2',
                label: t('tournaments.type'),
                children: <Space>{event.type.desc}</Space>
              },
              {
                key: '3',
                label: t('tournaments.participants'),
                children: <Space>{event.playerAttendancy}</Space>
              },
            ]
            if (event.playerCap > 0) {
              pe.push({
                key: '4',
                label: t('tournaments.cap'),
                children: <Space>{event.playerCap}</Space>
              })
            }
            return (
              <Col span={24}>
                <Link to={'/tournaments/'+event.id+'/'}>
                  <Card className={`season-card ${checkStatus(event)}`} style= {{ width: '100%', marginBottom: '8px'}} title={event.name}>
                    <Descriptions size="small" title={t('tournaments.info')} items={pe} column={{ xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }} />
                  </Card>
                </Link>
              </Col>
            )
        })
      }
    </Card>
    </motion.div>
  );
}

export default League;